import { render } from "./NodeDescription.vue?vue&type=template&id=71896122"
import script from "./NodeDescription.vue?vue&type=script&lang=js"
export * from "./NodeDescription.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__